import React from 'react';
import {connect} from "react-redux";
import {change} from "redux-form";
import {Button, REDUX_FORM_NAME} from "react-admin";
import Popconfirm from "./Popconfirm";
import SaveIcon from '@material-ui/icons/Save';

const SaveWithConfirmButton = ({confirmTitle = '', ...restProps}) => {
    const handleClick = async () => {
        const { dispatch, handleSubmitWithRedirect, redirect } = restProps;

        await dispatch(change(REDUX_FORM_NAME, 'authStatus', 'AUTHORIZED'));
        handleSubmitWithRedirect(redirect)()
    }

    return <Popconfirm title={confirmTitle} onConfirm={handleClick}>
        <Button label='ra.action.save' variant='contained' style={{padding: '8px 16px'}}>
            <SaveIcon />
        </Button>
    </Popconfirm>
};

export default connect(null, null)(SaveWithConfirmButton)
